export default __webpack_public_path__ + "static/media/cricketicon.1ef020b4.png";